import styled from 'styled-components';

export const AlertContainer = styled.div`
  margin: 2rem;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MessageWrapper = styled.span`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
